lmApp
  .controller('GroupController', ['$scope', '$templateCache', '$rootScope', '$compile', '$q', '$timeout', '$routeParams', '$location', 'GroupService', 'GroupResource', 'AssetService', 'SubscriberService', 'ValidatorService', 'ToastService', 'ManageAssetsWindow', 'ModalWindowService', 'ManageSubscribersWindow',
    function ($scope, $templateCache, $rootScope, $compile, $q, $timeout, $routeParams, $location, GroupService, GroupResource, AssetService, SubscriberService, ValidatorService, ToastService, ManageAssetsWindow, ModalWindowService, ManageSubscribersWindow) {
      $scope.loading = false;
      $scope.groupCollection = [];
      $scope.search = {
        isShown: false,
        searchField: ''
      };
      $scope.activeGroup = {};
      $scope.newGroup = {};
      $scope.newGroup._PrivateData = {};
      $scope._tab = 'packages';

      $scope.specialGroup = {
        name: 'Everyone',
        _packageCount: -1,
        tooltip: ''
      };

      $scope.isCurrentTab = function (tab) {
        return $scope._tab === tab;
      };

      $scope.setCurrentTab = function (tab) {
        $scope._tab = tab;
      };

      $rootScope.EVENTS = _.extend($rootScope.EVENTS, {UPDATE_GROUP_COLLECTION: 'update.group.collection'});

      var _ParseGroup = function (group) {
        group._PrivateData = {};
        group._PrivateData.selectedAsset = [];
        group._PrivateData.selectedUser = [];
        group._PrivateData.validateErrors = {};
        group._PrivateData.name = group.name;

        $rootScope.showLinearProgress('#assetLoader' + group.id);
        group._PrivateData.assetLoading = true;

        $rootScope.showLinearProgress('#userLoader' + group.id);
        group._PrivateData.userLoading = true;

        AssetService.SearchByKeyword('', {groups: [group.id], onlyPackages: true}, 0, 10000)
          .then(function (collection) {
            $rootScope.hideLinearProgress('#assetLoader' + group.id);
            group._PrivateData.assetLoading = false;

            group._PrivateData.assets = collection;
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#assetLoader' + group.id);
            group._PrivateData.assetLoading = false;
            $rootScope.debugInfo(reason, 'silent');

            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });

        SubscriberService.GetSubscribersByGroup([group.id])
          .then(function (collection) {
            $rootScope.hideLinearProgress('#userLoader' + group.id);
            group._PrivateData.userLoading = false;

            group._PrivateData.users = collection;
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#userLoader' + group.id);
            group._PrivateData.userLoading = false;
            $rootScope.debugInfo(reason, 'silent');

            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });

        return group;
      };

      $scope.updateGroupCollection = function () {
          $rootScope.showLinearProgress('#groupLoader');
          $scope.loading = true;
          GroupService.GetGroups()
            .then(function (collection) {
              $rootScope.hideLinearProgress('#groupLoader');
              $scope.loading = false;
              $scope.groupCollection = collection;
              var assetMap = {
                0: []
              };

              if ($scope.groupCollection.length && $scope.routeGroupId) {
                var group = _.find($scope.groupCollection, {id: $scope.routeGroupId});
                if (group) {
                  $scope.setActiveGroup(group);
                }
              }

              $scope.groupCollection.forEach(function (group) {
                group._userCount = -1;
                group._packageCount = -1;
              });

              AssetService.SearchByKeyword('', {onlyPackages: true}, 0, 10000)
                .then(function (collection) {
                  collection.forEach(function (asset) {
                    if (asset.group_id.length > 0) {
                      asset.group_id.forEach(function (groupId) {
                        if (!assetMap.hasOwnProperty(groupId)) assetMap[groupId] = [];
                        assetMap[groupId].push(asset);
                      })
                    } else {
                      assetMap[0].push(asset);
                    }
                  });

                  var titles = [];
                  assetMap[0].forEach(function (package) {
                    var status = 'inactive';
                    if (package.is_available) {
                      status = 'active';
                    }
                    var assetsCount = 0;
                    if (package.assets) {
                      assetsCount = package.assets.length;
                    }
                    titles.push(package.title + ' (' + status + ', ' + assetsCount + ' assets)')
                  });
                  titles.push("+ all channels/VODs without package");
                  $scope.specialGroup._packageCount = assetMap[0].length;
                  $scope.specialGroup.tooltip = titles.join('<br/>');

                  $scope.groupCollection.forEach(function (group) {
                    if (assetMap.hasOwnProperty(group.id)) {
                      group._packageCount = assetMap[group.id].length;
                    } else {
                      group._packageCount = 0;
                    }
                    return group;
                  });

                  return collection;
                })
                .catch(function (reason) {
                  $rootScope.hideLinearProgress('#groupLoader');
                  $scope.loading = false;
                  $rootScope.debugInfo(reason, 'silent');
                  ToastService.Small({
                    title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                    color: 'amber',
                    icon: 'server-off',
                    blocked: true
                  }, 1000 * 5);
                });

              $scope.groupCollection.forEach(function (group) {
                SubscriberService.GetSubscribersByGroup([group.id])
                 .then(function (collection) {
                   group._userCount = collection.length;
                   return group
                 })
                 .catch(function (reason) {
                   $rootScope.hideLinearProgress('#groupLoader');
                   $scope.loading = false;
                   $rootScope.debugInfo(reason, 'silent');
                   ToastService.Small({
                     title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                     color: 'amber',
                     icon: 'server-off',
                     blocked: true
                   }, 1000 * 5);
                 });
                return group;
              });
            })
            .catch(function (reason) {
              $rootScope.hideLinearProgress('#groupLoader');
              $scope.loading = false;
              $rootScope.debugInfo(reason, 'silent');

              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
            });
      };

      $scope.toggleSearch = function (group) {
        $scope.search.isShown = !$scope.search.isShown;
      };

      $scope.isActiveGroupSet = function () {
        return !_.isEmpty($scope.activeGroup);
      };

      $scope.setActiveGroup = function (group) {
        $scope.activeGroup = _ParseGroup(group);
        $location.search('group_id', group.id);
      };

      $scope.clearActiveGroup = function () {
        $scope.activeGroup = {};
        $location.search('group_id', null);
      };

      $scope.toggleAssetSelection = function (group, asset) {
        var idx = group._PrivateData.selectedAsset.indexOf(asset);

        if (!asset.isSelected) {
          asset.isSelected = false;

          if (idx !== -1) {
            group._PrivateData.selectedAsset.splice(idx, 1);
          }
        } else {
          asset.isSelected = true;

          if (idx === -1) {
            group._PrivateData.selectedAsset.push(asset);
          }
        }
      };

      $scope.removeSelectedAsset = function (group) {
        if (group._PrivateData.assetLoading) return;

        $scope.loading = true;
        $rootScope.showLinearProgress('#assetLoader' + group.id);

        var _ids = group._PrivateData.selectedAsset.map(function (asset) {
          return asset.id;
        });

        GroupService.RemoveAsset([group.id], _ids)
          .then(function (response) {
            $rootScope.hideLinearProgress('#assetLoader' + group.id);
            $scope.loading = false;
            ToastService.Small({
              title: 'Asset(s) successfully removed',
              color: 'green',
              icon: 'movie'
            }, 1000 * 3);

            $rootScope.$broadcast($rootScope.EVENTS.UPDATE_GROUP_COLLECTION);
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#assetLoader' + group.id);
            $scope.loading = false;
            $rootScope.debugInfo(reason);
            ToastService.Small({
              title: 'Asset(s) remove failed',
              color: 'red',
              icon: 'movie'
            }, 1000 * 3);
          })
      };

      $scope.manageAssetsFromGroup = function (toAdd, toRemove, toThis) {
        var allQ = {};

        if (toAdd.length) {
          var addIds = toAdd.map(function (asset) {
            return asset.id;
          });

          allQ.add = GroupService.AddAsset([toThis.id], addIds);
        }

        if (toRemove.length) {
          var removeIds = toRemove.map(function (asset) {
            return asset.id;
          });

          allQ.remove = GroupService.RemoveAsset([toThis.id], removeIds);
        }

        return allQ;
      };

      $scope.openAssetWindow = function (group, index) {
        if (group._PrivateData.assetLoading) return;

        ManageAssetsWindow.OpenManageAssetsWindow({
          manageAssetsFn: $scope.manageAssetsFromGroup,
          obj: group,
          index: index,
          data: 'group',
          onlyPackages: true,
          currentCollection: _.map(group._PrivateData.assets, 'id'),
          title: group.name
        })
      };

      $scope.toggleUserSelection = function (group, user) {
        var idx = group._PrivateData.selectedUser.indexOf(user);

        if (!user.isSelected) {
          user.isSelected = false;

          if (idx !== -1) {
            group._PrivateData.selectedUser.splice(idx, 1);
          }
        } else {
          user.isSelected = true;

          if (idx === -1) {
            group._PrivateData.selectedUser.push(user);
          }
        }
      };

      $scope.removeSelectedUser = function (group) {
        if (group._PrivateData.userLoading) return;

        $scope.loading = true;
        $rootScope.showLinearProgress('#userLoader' + group.id);

        var _ids = group._PrivateData.selectedUser.map(function (user) {
          return user.id;
        });

        GroupService.RemovePrincipal([group.id], _ids)
          .then(function (response) {
            $rootScope.hideLinearProgress('#userLoader' + group.id);
            $scope.loading = false;
            ToastService.Small({
              title: 'User(s) successfully removed',
              color: 'green',
              icon: 'account'
            }, 1000 * 3);

            $rootScope.$broadcast($rootScope.EVENTS.UPDATE_GROUP_COLLECTION);
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#userLoader' + group.id);
            $scope.loading = false;
            $rootScope.debugInfo(reason);
            ToastService.Small({
              title: 'User(s) remove failed',
              color: 'red',
              icon: 'account'
            }, 1000 * 3);
          })
      };

      var manageSubscribersFromModal = function (toAdd, toRemove, toThis) {
        if ($scope.loading) return;

        var allQ = {};

        if (toAdd.length) {
          var addIds = toAdd.map(function (subscriber) {
            return subscriber.id;
          });
          allQ.add = GroupService.AddPrincipal([toThis.id], addIds);
        }

        if (toRemove.length) {
          var removeIds = toRemove.map(function (subscriber) {
            return subscriber.id;
          });
          allQ.remove = GroupService.RemovePrincipal([toThis.id], removeIds);
        }

        return allQ;
      };

      $scope.openUserWindow = function (group) {
        ManageSubscribersWindow.Open({
          manageSubscribersFn: manageSubscribersFromModal,
          title: 'adding/removing group "' + group.name + '"',
          filter: {},
          obj: group,
          currentCollection: _.map(group._PrivateData.users, 'id')
        });
      };

/*      $scope.openUserWindow = function (group) {
        if (group._PrivateData.userLoading) return;

        $scope.innerScope = $scope.$new();

        $scope.innerScope.userSearch = '';
        $scope.innerScope.loading = false;

        $scope.innerScope.users = [];
        $scope.innerScope.toRemove = [];
        $scope.innerScope.toAdd = [];

        $scope.innerScope.loading = true;
        SubscriberService.GetSubscribers()
          .then(function (collection) {
            $scope.innerScope.loading = false;
            $scope.innerScope.users = collection;
            $scope.innerScope.$watch('userSearch', function (newValue, oldValue) {
              $scope.innerScope.users.forEach(function (user) {
                user.inSelection = !!_.find(group._PrivateData.users, {id: user.id});
                return user;
              });
            });
          })
          .catch(function () {
            $scope.innerScope.loading = false;
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });

        $scope.innerScope.addUser = function (user) {
          user.inSelection = true;

          var inNew = false;
          $scope.innerScope.toRemove.forEach(function (item, index, collection) {
            if (item.id === user.id) {
              collection.splice(index, 1);
              inNew = true;
            }
          });

          if (!inNew) $scope.innerScope.toAdd.push(user);
        };

        $scope.innerScope.removeUser = function (user) {
          user.inSelection = false;

          var inNew = false;
          $scope.innerScope.toAdd.forEach(function (item, index, collection) {
            if (item.id === user.id) {
              collection.splice(index, 1);
              inNew = true;
            }
          });

          if (!inNew) $scope.innerScope.toRemove.push(user);
        };

        var _inner_ = $templateCache.get('add-user-to-group.html');
        _inner_ = $compile(_inner_)($scope.innerScope);

        ModalWindowService.Open({
          content: _inner_,
          isFixed: true,
          actions: [
            {
              title: 'Add',
              color: 'teal',
              fn: function () {
                if ($scope.loading) return;

                var allQ = {};

                if ($scope.innerScope.toAdd.length) {
                  var addIds = $scope.innerScope.toAdd.map(function (asset) {
                    return asset.id;
                  });

                  allQ.add = GroupService.AddPrincipal([group.id], addIds);
                }

                if ($scope.innerScope.toRemove.length) {
                  var removeIds = $scope.innerScope.toRemove.map(function (asset) {
                    return asset.id;
                  });

                  allQ.remove = GroupService.RemovePrincipal([group.id], removeIds);
                }

                $q.all(allQ)
                  .then(function () {
                    $rootScope.hideLinearProgress('#modalLoader');
                    $scope.innerScope.loading = false;
                    ToastService.Small({
                      title: 'User(s) successfully added/removed',
                      color: 'green',
                      icon: 'package-down'
                    }, 1000 * 3);
                    $rootScope.$broadcast($rootScope.EVENTS.UPDATE_GROUP_COLLECTION);
                  })
                  .catch(function (reason) {
                    ToastService.Small({
                      title: 'Error happened',
                      color: 'red',
                      icon: 'package-down'
                    }, 1000 * 3);
                    $rootScope.debugInfo(reason);
                    $rootScope.hideLinearProgress('#modalLoader');
                    $scope.innerScope.loading = false;
                  });
              }
            },
            {
              title: 'Cancel',
              color: 'red'
            }
          ],
          onComplete: function () {
            $scope.innerScope.$destroy();
          },
          size: {
            s: 4
          }
        });
      };*/

      $scope.createNewGroup = function () {
        $scope._createInner_ = $templateCache.get('add-group.html');
        $scope._createInner_ = $compile($scope._createInner_)($scope);

        ModalWindowService.Open({
          content: $scope._createInner_,
          actions: [
            {
              title: 'Create',
              color: 'green',
              fn: function () {
                var extId = "group:" + translit($scope.newGroup._PrivateData.title);

                GroupService.CreateGroup(extId, $scope.newGroup)
                  .then(function (response) {
                    $scope.newGroup = {};
                    ToastService.Small({
                      title: 'Group successfully created',
                      color: 'green',
                      icon: 'source-fork'
                    }, 1000 * 3);
                    $scope.groupCollection.unshift(_ParseGroup(response.group));
                    $rootScope.hideLinearProgress('#modalLoader');
                    $scope.loading = false;
                  })
                  .catch(function (reason) {
                    ToastService.Small({
                      title: 'Group create failed',
                      color: 'red',
                      icon: 'source-fork'
                    }, 1000 * 3);
                    $rootScope.debugInfo(reason);
                    $rootScope.hideLinearProgress('#modalLoader');
                    $scope.loading = false;
                  });
              }
            },
            {
              title: 'Cancel',
              color: 'red'
            }
          ],
          keyboard: true
        });
      };

      $scope.updateGroup = function (group) {
        group._PrivateData.validateErrors = {};

        if (!group._PrivateData.name) {
          group._PrivateData.validateErrors.name = true;
          return;
        }

        $scope.loading = true;
        $rootScope.showLinearProgress('#groupLoader');

        GroupService.UpdateGroup(group, group.parent_id)
          .then(function (response) {
            $rootScope.hideLinearProgress('#groupLoader');
            $scope.loading = false;
            ToastService.Small({
              title: 'Group successfully updated',
              color: 'green',
              icon: 'source-fork'
            }, 1000 * 3);

            $rootScope.$broadcast($rootScope.EVENTS.UPDATE_GROUP_COLLECTION);
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#groupLoader');
            $scope.loading = false;
            $rootScope.debugInfo(reason);
            ToastService.Small({
              title: 'Group update failed',
              color: 'red',
              icon: 'source-fork'
            }, 1000 * 3);
          })
      };

      $scope.removeGroup = function (group) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#groupLoader');

        $scope.modalWindowScope = $scope.$new();
        var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the group "' + group.name +'"?</span>';

        ModalWindowService.Open({
          content: inner,
          actions: [
          {
            title: 'I understand. Do it',
            color: 'green',
            fn: function () {
              GroupResource.remove({id: group.id}).$promise
                .then(function () {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#groupLoader');
                  ToastService.Small({
                    title: 'The group <b class="tc-white"> ' + group.name + '</b> successfully deleted',
                    color: 'green',
                    icon: 'delete'
                  }, 1000 * 3);
                  $rootScope.$broadcast($rootScope.EVENTS.UPDATE_GROUP_COLLECTION);
                  $scope.clearActiveGroup();
                })
                .catch(function (reason) {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#groupLoader');
                  $rootScope.debugInfo(reason);
                  ToastService.Small({
                    title: 'Failed to remove group',
                    color: 'red',
                    icon: 'delete'
                  });
                });
            }
          },
          {
            title: 'cancel',
            color: 'red',
            fn: function () {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#groupLoader');
            }
          }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      if (!$rootScope.$$listeners[$rootScope.EVENTS.UPDATE_GROUP_COLLECTION] || !$rootScope.$$listeners[$rootScope.EVENTS.UPDATE_GROUP_COLLECTION].length) {
        $rootScope.$on($rootScope.EVENTS.UPDATE_GROUP_COLLECTION, function (event) {
          $scope.updateGroupCollection();
        });
      }

      $scope.routeGroupId = null;
      if ($routeParams.group_id) {
        $scope.routeGroupId = Number($routeParams.group_id);
      }

      $scope.$on('$routeUpdate', function () {
        if ($scope.routeGroupId && !$routeParams.group_id) {
          $scope.clearActiveGroup();
        }
        $scope.routeGroupId = Number($routeParams.group_id) || null;
      });

      $rootScope.$broadcast($rootScope.EVENTS.UPDATE_GROUP_COLLECTION);

      $scope.$on('$destroy', function () {
        $rootScope.$$listeners[$rootScope.EVENTS.UPDATE_GROUP_COLLECTION] = [];
      });

    }]);
